<template>
  <div>
    <NavigationBar />
    <VNotification
      :key="JSON.stringify(notification)"
      class="absolute top-22 right-4 w-96"
      :show="!!notification"
      :delay="notification ? notification.delay : 0"
      :type="(notification && notification.type) ?? undefined"
      @dismissed="setNotification(null)"
    >
      <template #title>{{ notification && notification.title }}</template>
      <template v-if="notification && notification.text" #default>{{ notification.text }}</template>
    </VNotification>
    <form class="text-center mt-32" @submit.prevent="submit">
      <h2 class="text-6xl mb-6">Password Protected Content</h2>
      <p class="text-2xl mb-4">Enter the password to continue:</p>
      <div class="w-100 m-auto mb-8"><VInput v-model="password" type="password" name="password" /></div>
      <VButton class="block m-auto submit d-block" type="submit" variant="dark" :rounded="true" :disabled="password.length === 0">
        Unlock Access
      </VButton>
    </form>
  </div>
</template>

<script lang="ts" setup>
const password: Ref<string> = ref('')

definePageMeta({
  layout: 'isolated-page',
})

const { notification, setNotification } = useGlobalNotification()
const { hideAlert } = useAlerts()

const emit = defineEmits(['submit'])
const route = useRoute()
const { $analytics } = useNuxtApp()

function submit() {
  emit('submit', { password: unref(password) })
}

function _extractDeckIdentifierAnalyticsField(identifier: any) {
  if (isNaN(parseInt(identifier))) {
    return { urlSlug: identifier }
  }

  return { deckId: parseInt(identifier) }
}

onMounted(() => {
  $analytics.track('showedScreenDeckPassword', {
    ..._extractDeckIdentifierAnalyticsField(route.params.id),
    uuid: route.query?.UUID,
  })
})

onUnmounted(() => {
  hideAlert()
})
</script>
